import React, { useEffect, useState } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { useTypePosition } from '../../hooks'
import { TypePosition } from '../../interfaces/TypePosition'

interface TypePositionsDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  withoutThisPositions?: number[]
  required?: boolean
  includeNotEditable?: boolean
}

export const TypePositionsDDL: React.FC<TypePositionsDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  withoutThisPositions = [],
  required = false,
  includeNotEditable = true
}) => {
  const [hasError, setHasError] = useState<boolean>(false)
  const {
    typePositionsState: { typePositions },
    getTypePositions
  } = useTypePosition()

  useEffect(() => {
    if (typePositions?.length === 0) {
      getTypePositions()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value === -1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrTypePositions =
    typePositions !== undefined
      ? typePositions
          .filter((item) => !withoutThisPositions.includes(item.typePositionId))
          .map(
            (option: TypePosition) =>
              //valida flag, para ver si puede editar posiciones de packing
              (!includeNotEditable && !option.canUpdatePosition) || (
                <MenuItem
                  key={option.typePositionId}
                  value={option.typePositionId}
                >
                  {option.typePositionDescription}
                </MenuItem>
              )
          )
      : []

  return (
    <TextField
      variant={type}
      id='typepositionId'
      name='typepositionId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      error={hasError} // Aplicar el estado de error al TextField
      helperText={hasError ? 'Seleccionar Opción' : undefined}
    >
      <MenuItem key={-1} value={-1}>
        {'Seleccionar Tipo Posición...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
